<template>
  <div>
    <!-- 矩阵下拉 -->
    <div>
      <div class="matrix-scale" v-for="(rowItem, id) of rowData.questionDetails.issue.rows" :key="id">
        <h4 v-html="transformHtml(rowItem.content.richText)" />
        <template v-for="(col, idx) in rowData.questionDetails.issue.items">
          <div class="flex justify-start">
            <!-- <h5 class="flex-shrink-0">{{ col.content.text }}</h5> -->
            <h5 v-html="transformHtml(col.content.richText)" />
            <el-select
              v-model="getMatrixSelect(rowItem, col).model"
              placeholder="请选择"
              @change="changeMatrixSelect($event, rowItem, col)"
            >
              <el-option
                v-for="item in getMatrixSelect(rowItem, col).options"
                :key="item.id"
                :label="item.content.text"
                :value="item.id"
              >
                <template>
                  <el-tooltip
                    :disabled="item.content.text < 22"
                    class="tooltip-style"
                    effect="light"
                    :content="item.content.text"
                    placement="top"
                  >
                    <span style="max-width: 350px; display: inline-block; overflow: hidden; text-overflow: ellipsis">{{
                      item.content.text
                    }}</span>
                  </el-tooltip>
                </template>
              </el-option>
            </el-select>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import '../public/style.css'
import { itemInitOptions } from '../config/config.js'
import mixins from '../mixins'
import { saveArr } from '../public/index.js'

export default {
  mixins: [mixins],
  name: 'MatrixSelect',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    // 矩阵下拉 v-model
    getMatrixSelect() {
      return function (rowItem, col) {
        const cells = this.rowData.questionDetails.issue.cells // 选项
        const modelId = this.rowData.items.find(item => {
          return item.rowId === rowItem.row_id && item.colId === col.id
        })
        const options = cells.find(it => {
          return it.col_id === col.id && it.row_id === rowItem.row_id
        }).items
        let model = modelId ? modelId.optionId : ''
        return { model, options }
      }
    }
  },
  inject: ['transformHtml'],
  methods: {
    // 矩阵下拉题 change事件
    changeMatrixSelect(val, rowItem, col) {
      const optionName = this.rowData.questionDetails.issue.cells
        .find(item => {
          return item.col_id === col.id && item.row_id === rowItem.row_id
        })
        .items.find(ci => {
          return ci.id === val
        }).content.text
      let matchAnswer = this.rowData.items.find(item => {
        return item.colId === col.id && item.rowId === rowItem.row_id
      })
      if (matchAnswer) {
        matchAnswer.optionId = val
        matchAnswer.value = optionName
      } else {
        this.rowData.items.push(
          Object.assign({}, itemInitOptions, {
            colId: col.id,
            rowId: rowItem.row_id,
            optionId: val,
            value: optionName
          })
        )
      }
      // let ids = this.updateArr.indexOf(this.rowData)
      // if (ids === -1) {
      //   this.updateArr.push(this.rowData)
      // }
      this.saveArr()
    },
    saveArr
  }
}
</script>

<style lang="scss" scoped></style>
